import { IMessage } from '../interfaces/message.interface';

export class ToasterHelper {
  private static readonly _defaultErrorMessage = 'An error occurred!';
  private static readonly _defaultSuccessMessage = 'Success!';

  static errorMessage(text?: string): IMessage {
    return {
      severity: 'error',
      summary: text ?? this._defaultErrorMessage,
      icon: 'pi-times-circle',
      closable: false,
      life: 4000,
    };
  }

  static successMessage(text?: string): IMessage {
    return {
      severity: 'success',
      summary: text ?? this._defaultSuccessMessage,
      icon: 'pi-check-circle',
      closable: false,
    };
  }
}
